import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { PurposeByUserIdRequest, PurposeByUserIdResponse } from 'app/model/user/consent-model';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UserService } from 'app/services/user/user.service';
import { DialogAlertComponent } from '../modal/dialog-alert/dialog-alert.component';
import { ToggleButtonComponent } from '../toggle-button/toggle-button.component';

@Component({
  selector: 'act-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent {

  @Input() subscriptionData: PurposeByUserIdResponse;
  @Output() onToggle: EventEmitter<any> = new EventEmitter();

  @ViewChildren('toggle') toggleButtonComponent: QueryList<ToggleButtonComponent>;

  public lang = this.appConfigService.getLanguage();

  constructor(
    private appConfigService: AppConfigService,
    private userService: UserService,
    private dialog: MdDialog
  ) { }

  onTogglePurpose(action: boolean, purposeId: number) {
    const request = new PurposeByUserIdRequest();
    request.consentId = this.subscriptionData.consentId;
    request.purposeId = purposeId;
    this.userService.updatePurposeByUserId(this.userService.getUser().userId, action ? 'accept' : 'withdraw', request)
      .subscribe(() => true, () => {
        try {
          this.toggleButtonComponent.find(f => f.name === `purpose-${purposeId}`).on = !action;
        } catch (e) { }
        const dialogAlertRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent);
        dialogAlertRef.componentInstance.alertText = this.appConfigService.getTranslate('system-error');
        dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
        dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/subscription/subscription.component.ts